
import { Box, PageTitle,Tabs ,    Text } from "@flexisaf/flexibull2";
import { RiFeedbackLine } from "react-icons/ri";
import Theme from "../../theme";
import Faculties from "./tabs/faculties";
import Departments from "./tabs/departments";

const ManageInstitutions = () => {
  return (
    <Box>
      <PageTitle>
        <RiFeedbackLine size={25} style={{ position: "absolute" }} />
        <Text bold size={Theme.H3} style={{ padding: "10px 35px" }}>
         Manage Institutions
        </Text>
      </PageTitle>

      <Tabs responsive={false} bgColor="none" style={{ maxWidth: '100%' }}>
          <Box label="Faculties">
            <Faculties />
          </Box>
          <Box label="Departments">
            <Departments  />
          </Box>
        </Tabs>
    </Box>
  );
};

export default ManageInstitutions;

